export const selectUsers = state => state.users || {};
export const selectCreateUserError = state => selectUsers(state).createUserError;
export const selectSubmittingUser = state => selectUsers(state).submittingUser;
